module.exports = __webpack_public_path__ + "img/blue_talk.7dd94e04.gif";